// Generate random amount between min and max
const randomAmount = (min, max) => 
  Number((Math.random() * (max - min) + min).toFixed(2));

// Generate random date within last 30 days
const randomDate = () => {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - 30);
  return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
};

const mockTransactionTypes = [
  { type: 'debit', description: 'Amazon Purchase' },
  { type: 'debit', description: 'Walmart Store' },
  { type: 'debit', description: 'Target' },
  { type: 'debit', description: 'Shell Gas' },
  { type: 'debit', description: 'Netflix Subscription' },
  { type: 'debit', description: 'Uber Ride' },
  { type: 'debit', description: 'Starbucks' },
  { type: 'credit', description: 'Direct Deposit - Employer' },
  { type: 'credit', description: 'Bank Transfer Credit' },
  { type: 'credit', description: 'Refund - Amazon' },
  { type: 'debit', description: 'Phone Bill Payment' },
  { type: 'debit', description: 'Electric Bill Payment' },
  { type: 'debit', description: 'Internet Payment' },
  { type: 'debit', description: 'Restaurant Payment' },
  { type: 'credit', description: 'Bank Transfer' }
];

export const generateMockTransactions = (count = 20) => {
  return Array.from({ length: count }, () => {
    const transaction = mockTransactionTypes[Math.floor(Math.random() * mockTransactionTypes.length)];
    return {
      type: transaction.type,
      description: transaction.description,
      amount: transaction.type === 'credit' 
        ? randomAmount(100, 3000)
        : randomAmount(5, 200),
      date: randomDate(),
      status: 'completed',
      category: transaction.type === 'credit' ? 'income' : 'expense'
    };
  }).sort((a, b) => b.date - a.date);
};

export const initialAccounts = [
  {
    type: 'Current',
    accountNumber: '12345678',
    balance: 2500.00,
    routingNumber: '021000021'
  },
  {
    type: 'Savings',
    accountNumber: '87654321',
    balance: 10000.00,
    routingNumber: '021000021'
  }
];

// Returns mock transactions with dates relative to "now" so they always look recent
function daysAgo(days, hour = 10, minute = 0) {
  const d = new Date();
  d.setDate(d.getDate() - days);
  d.setHours(hour, minute, 0, 0);
  return d;
}

export function getMockTransactions() {
  const now = new Date();
  return [
    {
      id: 'mock-1',
      description: 'Direct Deposit - Employer Payroll',
      amount: 2850.00,
      type: 'credit',
      date: daysAgo(2, 10, 0),
      category: 'Income',
      status: 'Completed',
      isMock: true
    },
    {
      id: 'mock-2',
      description: 'Monthly Rent Payment',
      amount: 1500.00,
      type: 'debit',
      date: daysAgo(5, 9, 30),
      category: 'Housing',
      status: 'Completed',
      isMock: true
    },
    {
      id: 'mock-3',
      description: 'Grocery Purchase - Walmart',
      amount: 156.78,
      type: 'debit',
      date: daysAgo(3, 15, 45),
      category: 'Shopping',
      status: 'Completed',
      isMock: true
    },
    {
      id: 'mock-4',
      description: 'Car Insurance - Quarterly Payment',
      amount: 385.00,
      type: 'debit',
      date: daysAgo(14, 11, 20),
      category: 'Insurance',
      status: 'Completed',
      isMock: true
    },
    {
      id: 'mock-5',
      description: 'ATM Withdrawal',
      amount: 100.00,
      type: 'debit',
      date: daysAgo(21, 14, 15),
      category: 'Withdrawal',
      status: 'Completed',
      isMock: true
    }
  ].sort((a, b) => b.date.getTime() - a.date.getTime());
}

export const DEFAULT_ACCOUNTS = [
  {
    type: 'Current',
    accountNumber: '12345678',
    balance: 2500.00,
    available: 2500.00,
    routingNumber: '021000021'
  },
  {
    type: 'Savings',
    accountNumber: '87654321',
    balance: 10000.00,
    available: 10000.00,
    routingNumber: '021000021'
  }
]; 